import { useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function NotifyForm({ productId, slug, context = "restock-coming-soon" }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    try {
      await api.post("/notify", { product_id: productId, email });
      setDone(true);
    } catch {
      toast.error("Could not save your email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    // Context-aware confirmation so the restock flow (stock === 0) reads
    // correctly instead of "at launch" copy borrowed from coming-soon.
    const doneCopy =
      context === "restock"
        ? "We'll email you when it's back in stock."
        : "We'll email you at launch.";
    return (
      <p className="flex items-center gap-1.5 text-sm font-semibold text-green-700" data-testid={`notify-done-${slug}`}>
        <Check className="h-4 w-4" strokeWidth={3} /> {doneCopy}
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full gap-2" data-testid={`notify-form-${slug}`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@research.org"
        className="min-w-0 flex-1 rounded-md border border-line px-3 py-2 text-sm outline-none focus:border-brandblue focus:ring-2 focus:ring-brandblue/20"
        data-testid={`notify-email-${slug}`}
      />
      <button
        type="submit"
        disabled={loading}
        className="btn-pill shrink-0 bg-navy px-4 py-2 text-xs font-bold tracking-wide text-white hover:bg-navydark disabled:opacity-60"
        data-testid={`notify-submit-${slug}`}
      >
        {loading ? "…" : "Notify me →"}
      </button>
    </form>
  );
}
